module.exports = __webpack_public_path__ + "img/bank-right.d3b1ba85.png";